export default __webpack_public_path__ + "static/media/world.99e00c5c.svg";